// Two-level anatomical taxonomy: organ (coarse) -> region (finer).
// Used as suggestions only — both fields accept free-text manual override.
export const REGION_TAXONOMY = {
  "Neuro": ["Cerveau", "Moelle épinière", "Rachis"],
  "Tête & cou": ["Thyroïde", "ORL", "Orbite"],
  "Thorax": ["Poumon", "Cœur", "Médiastin", "Plèvre"],
  "Abdomen": [
    "Foie",
    "Pancréas",
    "Rate",
    "Reins",
    "Surrénales",
    "Estomac",
    "Œsophage",
    "Intestin grêle",
    "Côlon",
  ],
  "Pelvis": ["Vessie", "Utérus / Ovaires", "Prostate"],
  "Musculo-squelettique": [
    "Rachis",
    "Épaule",
    "Genou",
    "Hanche",
    "Membre supérieur",
    "Membre inférieur",
    "Pied / Main",
  ],
  "Vasculaire": ["Aorte", "Artères périphériques"],
};

export const ORGANS = Object.keys(REGION_TAXONOMY);

export const subRegionsFor = (organ) => REGION_TAXONOMY[organ] || [];

export const ALL_REGIONS = [
  ...new Set(Object.values(REGION_TAXONOMY).flat()),
];
